import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty, isNil } from 'lodash';
import GeoJSONLayer from './GeoJSONLayer';

const valueOr = (value, fallback) => (isNil(value) ? fallback : value);

export default class Area extends React.Component {
  layers() {
    const { color, opacity, fillColor, fillOpacity, stroke, weight } = this.props;
    const { defaultProps } = Area;

    return [
      {
        type: 'fill',
        paint: {
          'fill-color': valueOr(fillColor, defaultProps.fillColor),
          'fill-opacity': Number(valueOr(fillOpacity, defaultProps.fillOpacity))
        }
      },
      {
        type: 'line',
        paint: {
          'line-color': valueOr(color, defaultProps.color),
          'line-opacity': Number(valueOr(opacity, defaultProps.opacity)),
          'line-width': Number(valueOr(weight, defaultProps.weight))
        },
        layout: { 'line-join': 'round', visibility: stroke === false ? 'none' : 'visible' }
      }
    ];
  }

  render() {
    if (isEmpty(this.props.area)) return null;

    return <GeoJSONLayer data={this.props.area} layers={this.layers()} includeInBounds />;
  }
}

Area.defaultProps = {
  color: '#333',
  opacity: 0.8,
  fillColor: '#333',
  fillOpacity: 0.5,
  weight: 3
};

Area.propTypes = {
  area: PropTypes.object.isRequired,
  color: PropTypes.string,
  opacity: PropTypes.number,
  fillColor: PropTypes.string,
  stroke: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  weight: PropTypes.number,
  fillOpacity: PropTypes.number
};
